
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("9s8yO", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $6e1d5e7e126570b2$export$2cd8252107eb640b; });

var $jG4hL = parcelRequire("jG4hL");
var $6e1d5e7e126570b2$export$2cd8252107eb640b = ()=>{
    var $flyoutMenu = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".flyout-menu");
    var $burgerBtn = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".btn--burger"); //  || $header.find('.btn--burger-2')
    var $header = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".header");
    var $mainNav = $header.find(".main-nav");
    var isFlyoutHidden = true;
    var isWideScreen = window.innerWidth > 991;
    // Method to hide mobile flyout
    var hideMobileMainNav = function hideMobileMainNav() {
        $mainNav.addClass("main-nav--hidding").removeClass("show");
        setTimeout(function() {
            $mainNav.removeClass("main-nav--hidding");
        }, 500);
    };
    /**
   * Utility method to hide flyout with CSS effect
   *
   * @param {Boolean} closeMenu - indicates that the main navigation should also be closed
   * (normally when clicked) outside of the flyout
   */ var closeFlyoutMenu = function closeFlyoutMenu(closeMenu) {
        if (isFlyoutHidden) return;
        $burgerBtn.removeClass("active");
        $header.removeClass("header--opened-flyout");
        $flyoutMenu.removeClass("show");
        isFlyoutHidden = true;
        if (closeMenu) {
            $mainNav.find("ul").children().removeAttr("style");
            hideMobileMainNav();
        }
    };
    /**
   * Handles click event outside of flyout menu (backdrop)
   *
   * @param {Event} e - click event
   */ var _clickOutFlyoutHandler = function clickOutFlyoutHandler(e) {
        var targetEl = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(e.target);
        if (targetEl.closest($flyoutMenu).length || targetEl.closest($mainNav).length || targetEl.closest($header).length && !$flyoutMenu.find(".flyout-menu-close").length) return;
        $mainNav.find("li").removeClass("active");
        $burgerBtn.removeClass("active");
        closeFlyoutMenu(true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("body").off("click", _clickOutFlyoutHandler);
    };
    /**
   * Activates flyout menu considering screen orientation
   *
   * @param {JQuery} menu - Flout parent menu item
   */ var showFlyoutMenu = function showFlyoutMenu(menu) {
        isFlyoutHidden = false;
        if (!isWideScreen) {
            $header.addClass("header--mobile-flyout");
            $flyoutMenu.addClass("show");
            menu.addClass("active");
            return;
        }
        if (!$flyoutMenu.hasClass("show")) {
            $header.addClass("header--opened-flyout");
            $flyoutMenu.addClass("show");
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("body").on("click", _clickOutFlyoutHandler);
        }
        // Do not complete operations if the same menu is opened
        if (menu.hasClass("active")) return;
        menu.siblings(".active").removeClass("active");
        menu.addClass("active");
    };
    /**
   * Dispatch flyout behaviour
   * when click event of the main navigation is fired
   *
   * @param {Event} e
   */ var flyoutEventHandler = function flyoutEventHandler(e) {
        var dataMenu = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).data("menu");
        // Use as link if no data-menu dataset
        if (!dataMenu) return;
        e.preventDefault();
        var $this = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).parent();
        // console.log(dataMenu);
        // Close flyout in case of attempt to activate the same link
        if (e.type === "click" && $this.hasClass("active") && $flyoutMenu.hasClass("show")) {
            $this.removeAttr("style").removeClass("active");
            closeFlyoutMenu();
            return;
        }
        // Activate a new item in main navigation
        $this.siblings(".active").removeClass("active");
        $this.addClass("active");
        // Activate needed flyout group
        var menu = $flyoutMenu.find("[data-category=\"".concat(dataMenu, "\"]"));
        // Show flyout with category
        if (menu.length > 0) showFlyoutMenu(menu, !isWideScreen);
        else console.warn('%cMenu category "' + dataMenu + '" is not found in flyout.');
    };
    // Resize event handler
    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(window).on("resize", function(e) {
        if (!e.isTrigger) {
            clearTimeout(this._sltimer);
            this._sltimer = setTimeout(()=>{
                isWideScreen = window.innerWidth > 767;
            }, 250);
        }
    });
    // Attach Flyout event handlers
    $mainNav.find("li > a").on("click", flyoutEventHandler);
    $header.find('[data-js="close-flyout"]').on("click", closeFlyoutMenu);
    // Click on submenus that are commonly in flyout
    $flyoutMenu.find("[data-category]").on("click", function() {
        var $this = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this);
        if ($this.hasClass("active")) {
            $this.removeClass("active");
            $this.children(".flyout-menu__decor").remove();
        } else {
            $this.siblings(".active").removeClass("active");
            $this.addClass("active");
        }
    });
    // Back to main menu on mobile
    $flyoutMenu.find(".btn-back").on("click", function() {
        $mainNav.find(".active").removeClass("active");
        $header.removeClass("header--mobile-flyout");
        $flyoutMenu.find(".flyout-menu__category.active").removeClass("active");
        $flyoutMenu.removeClass("show");
    });
    $burgerBtn.on("click", function(e) {
        if ($mainNav.hasClass("show")) {
            $burgerBtn.removeClass("active");
            $mainNav.removeClass("show");
            $header.removeClass("header--mobile-flyout");
            $flyoutMenu.removeClass("show");
            $flyoutMenu.find(".flyout-menu__category.active").removeClass("active");
            isFlyoutHidden = true;
        } else {
            $burgerBtn.addClass("active");
            $mainNav.addClass("show");
            isFlyoutHidden = false;
        }
    });
};

});


//# sourceMappingURL=flyout.module.277f6ef2.js.map
